<div
  #menu
  [class.overflow-auto]="overflow()"
  class="bg-base-100 max-h-80 z-20 flex flex-col p-1 rounded-xl border border-base-content/6 shadow-[0_4px_24px_-4px_rgba(0,0,0,0.1),0_1px_4px_-1px_rgba(0,0,0,0.04)] min-w-max">
  <ng-content />
</div>
